import { CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { MaxBrainSharedModule } from 'app/projects/shared/src/lib/shared.module';
import { MaxBrainAllModulesModule } from '../all-modules/all-modules.module';
import { MaxBrainModuleModule } from '../module/module.module';
import { TagMultiSelectModule } from '../tag/components/multi-select/multi-select.module';
import { MyArchivedModulesListTableComponent } from './components/my-archived-modules-list-table/my-archived-modules-list-table.component';
import { MyEndedModulesListTableComponent } from './components/my-ended-modules-list-table/my-ended-modules-list-table.component';
import { MyModulesListComponent } from './components/my-modules-list/my-modules-list.component';
import { MyModulesToolbarComponent } from './components/my-modules-toolbar/my-modules-toolbar.component';
import { MyPinnedModulesListTableComponent } from './components/my-pinned-modules-list-table/my-pinned-modules-list-table.component';
import { MyPublishedModulesListTableComponent } from './components/my-published-modules-list-table/my-published-modules-list-table.component';
import { MyRunningModulesListTableComponent } from './components/my-running-modules-list-table/my-running-modules-list-table.component';
import { MyStudentModulesListComponent } from './components/my-student-modules-list/my-student-modules-list.component';
import { MyUnpublishedModulesListTableComponent } from './components/my-unpublished-modules-list-table/my-unpublished-modules-list-table.component';
import { MyUppcomingModulesListTableComponent } from './components/my-uppcoming-modules-list-table/my-uppcoming-modules-list-table.component';
import { MyModulesService } from './services/my-modules.service';
import { MaxBrainModuleManagersModule } from '../module-managers/module-managers.module';
import { CourseOfferingParticipantsModule } from '../course-offering-participants/course-offering-participants.module';
import { UserModuleRemoveParticipantService } from './services/user-module-remove-participant.service';

@NgModule({
    imports: [
        RouterModule,
        MaxBrainSharedModule,
        MatCheckboxModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatIconModule,
        MatSelectModule,
        MatInputModule,
        TagMultiSelectModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        MatButtonToggleModule,
        MatPaginatorModule,
        MaxBrainModuleModule,
        MatChipsModule,
        MatProgressBarModule,
        MaxBrainAllModulesModule,
        MaxBrainModuleManagersModule,
        CourseOfferingParticipantsModule,
    ],
    providers: [UserModuleRemoveParticipantService],
    declarations: [
        MyModulesListComponent,
        MyPinnedModulesListTableComponent,
        MyUppcomingModulesListTableComponent,
        MyArchivedModulesListTableComponent,
        MyRunningModulesListTableComponent,
        MyPublishedModulesListTableComponent,
        MyUnpublishedModulesListTableComponent,
        MyEndedModulesListTableComponent,
        MyStudentModulesListComponent,
        MyModulesToolbarComponent,
    ],
    exports: [
        MyModulesListComponent,
        MyPinnedModulesListTableComponent,
        MyUppcomingModulesListTableComponent,
        MyArchivedModulesListTableComponent,
        MyRunningModulesListTableComponent,
        MyPublishedModulesListTableComponent,
        MyUnpublishedModulesListTableComponent,
        MyEndedModulesListTableComponent,
        MyStudentModulesListComponent,
        MyModulesToolbarComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MaxBrainMyProfileModulesModule {
    static forRoot(): ModuleWithProviders<MaxBrainMyProfileModulesModule> {
        return {
            ngModule: MaxBrainMyProfileModulesModule,
            providers: [MyModulesService],
        };
    }
}
